
































import { defineComponent, PropType } from '@nuxtjs/composition-api';
import { WheelGift } from '~/features/gift-tiers';

export default defineComponent({
  name: 'GiftsWheel',
  props: {
    isSpinning: {
      type: Boolean,
      default: false,
    },
    finalRotationPosition: {
      type: Number,
      default: 0,
    },
    gifts: {
      type: Array as PropType<WheelGift[]>,
      default: () => [],
    },
    currentTier: {
      type: Number,
      default: 0,
    },
    displayOnly: {
      type: Boolean,
      default: false,
    },
  },
  setup() {
    const wheelColors = ['#A0F1B7', '#ECCEAA', '#DF8094'];

    return {
      wheelColors,
    };
  },
});
